module.exports = __webpack_public_path__ + "static/media/icon_checkbox.86787f09.svg";